import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { Rubrique } from '@app/nomenclature/nomenclature.model';
import { NomenclatureNodeData } from './nomenclature.service';

@Injectable({providedIn: 'root'})
@Pipe({name: 'nomenclature'})
export class NomenclaturePipe implements PipeTransform {

	constructor() {}

	transform(data: Partial<NomenclatureNodeData>, separator: string = ' > '): string {
		let tmp = '';
		if (typeof data.fam_nom != 'undefined') {
			tmp = this.append(tmp, data.fam_nom, separator);
		}
		if ('thm_nom' in data && typeof data.thm_nom != 'undefined') {
			tmp = this.append(tmp, data.thm_nom, separator);
		}
		if ('rub_nom' in data && typeof data.rub_nom != 'undefined') {
			tmp = this.append(tmp, data.rub_nom, separator);
		}
		return tmp;
	}

	append(str: string, more: string, separator: string = ' ') {
		if (str.length) {
			str = `${str}${separator}`;
		}
		return `${str}${more}`;
	}

}
